export var FontWeight;
(function (FontWeight) {
    FontWeight[FontWeight["Light"] = 300] = "Light";
    FontWeight[FontWeight["Regular"] = 400] = "Regular";
    FontWeight[FontWeight["SemiBold"] = 600] = "SemiBold";
})(FontWeight || (FontWeight = {}));
